import { setup } from "web/entrypoints/common/setup";
import "./css-lyst-news-article";
import { lystNewsArticleComponents } from "./lyst-news-article";

setup(lystNewsArticleComponents);
